import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { IoChevronForward } from 'react-icons/io5';

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

const containerVariants = {
  hidden: { opacity: 0, y: -8, scale: 0.95 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.2,
      ease: [0.4, 0, 0.2, 1]
    }
  },
  exit: {
    opacity: 0,
    y: -8,
    scale: 0.95,
    transition: { duration: 0.15 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, x: -10 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: {
      delay: i * 0.03,
      duration: 0.2,
      ease: 'easeOut'
    }
  })
};

export const SimpleDropdown = ({ data, onItemClick }) => {
  if (!data || !Array.isArray(data)) {
    return null;
  }

  // Check if this is gallery data (has imageCollection property) or company data
  const isGalleryData = data[0]?.imageCollection;

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={containerVariants}
             className="absolute right-0 left-0 top-full bg-white border border-gray-200/80 shadow-xl rounded-xl py-3 min-w-[220px] z-50 backdrop-blur-sm bg-white/95 before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:bg-gradient-to-r before:from-transparent before:via-gray-200 before:to-transparent">
      <div className="px-1">
        {data.map((item, index) => (
          <motion.div
            key={index}
            custom={index}
            variants={itemVariants}
            initial="hidden"
            animate="visible">
                         <Link
               to={item.slug ? (isGalleryData ? `/gallery/${item.slug}` : `/${item.slug}`) : item.link || '#'}
              onClick={() => {
                scrollToTop();
                onItemClick?.();
              }}
              className="group flex items-center justify-between px-4 py-2.5 text-sm text-gray-700 hover:bg-gradient-to-r hover:from-gray-50 hover:to-gray-100 hover:text-gray-900 transition-all duration-200 rounded-lg mx-1 hover:shadow-sm">
              <span className="font-medium tracking-wide">{item.title}</span>
              <IoChevronForward className="w-3.5 h-3.5 text-gray-400 group-hover:text-gray-600 transition-colors duration-200 group-hover:translate-x-0.5" />
            </Link>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};
